import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Self-hosted: no Google Fonts request, and no FOUT on the one screen where type IS the
// interface. Weights are exactly those design/README.md lists.
import "@fontsource/anton/400.css";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow-condensed/600.css";
import "@fontsource/barlow-condensed/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";

import "@trackmark/tokens/tokens.css";
import "./app.css";
import { App } from "./App.js";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
